import styled from 'styled-components';

import { baseFontFamily, baseFontSize } from 'views/services/font-scheme';
import { baseColor, textColor } from 'views/services/color-scheme';

export const Root = styled.article`
  position: relative;
  background-color: ${baseColor};
  border-radius: 8px;
  padding: 32px;
  width: 960px;
  & > h1 {
    font-family: ${baseFontFamily};
    font-size: calc(${baseFontSize} * 1.5);
    color: ${textColor};
  }
  & > fieldset {
    & > div {
      margin-top: 24px;
    }
  }
`;

export const Loading = styled.div`
  height: 480px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Footer = styled.footer`
  margin-top: 48px;
  font-size: calc(${baseFontSize} * 1);
  display: flex;
  justify-content: center;
  align-items: center;
`;
